import {
    Component,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { PROFILE_DATA_SERVICE, ProfileDataService } from '../../../../services/profile/profile-data.service';
import { UserProfileShareService } from '../../../../services/shared-service/user-profile-share.service';
import { RESOURCES_DATA_SERVICE, ResourcesDataService } from '../../../../services/resources/resources-data.service';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { Store } from '@ngxs/store';
import { CLOUD_DATA_SERVICE, CloudDataService } from '../../../../services/cloud/cloud-data.service';
import { AdminMandant, Area, Duplicate } from '../../../../models/cloud/cloud.model';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import { CONTACTS_DATA_SERVICE, ContactsDataService } from '../../../../services/contacts/contacts-data.service';
import { DateTimeHelper } from '../../../../helper/date-time.helper';
import { TextHelper } from '../../../../helper/text.helper';

@Component({
    selector: 'fi-duplicates',
    templateUrl: './duplicates.component.html',
    styleUrls: ['./duplicates.component.scss'],
  standalone: false,
})
export class DuplicatesComponent implements OnInit, OnChanges {
    @Input() mandant?: AdminMandant;

    passingDuplicates = new Map<Duplicate, boolean>();
    duplicates: Duplicate[] = [];
    searchFilterOpen = false;
    shiftToLeft = false;
    filterType: 'NONE' | 'NUMBER' | 'TEXT' | 'EMAIL' | 'LAST_NAME' |
        'FIRST_NAME' | 'TYPE' | 'DATE' | 'CREATOR' | 'EDITOR' | 'SOURCE' | 'COUNTRY' = 'NONE';
    multiselectOptions: {label: string, value: string} [] = [];
    selectedMultiselectOptions: {label: string, value: string} [] = [];
    filters: {type: 'NONE' | 'NUMBER' | 'TEXT' | 'EMAIL' | 'LAST_NAME' |
            'FIRST_NAME' | 'TYPE' | 'DATE' | 'CREATOR' | 'EDITOR' | 'SOURCE' | 'COUNTRY', value: string }[] = [];


    constructor(
        private readonly sharedProfileService: UserProfileShareService,
        @Inject(PROFILE_DATA_SERVICE) private readonly profileDataService: ProfileDataService,
        @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
        @Inject(CONTACTS_DATA_SERVICE) private contactsDataService: ContactsDataService,
        @Inject(RESOURCES_DATA_SERVICE) private resourcesDataService: ResourcesDataService,
        @Inject(ACTION_DATA_SERVICE) public actionDataService: ActionDataService,
        @Inject(CLOUD_DATA_SERVICE) public cloudDataService: CloudDataService,
        private fb: UntypedFormBuilder,
        private store: Store
    ) {

    }

    addFilter(type: 'NONE' | 'NUMBER' | 'TEXT' | 'EMAIL' | 'LAST_NAME' |
        'FIRST_NAME' | 'TYPE' | 'DATE' | 'CREATOR' | 'EDITOR' | 'SOURCE' | 'COUNTRY', value: string): void {

        if (!value?.trim()) {
            return;
        }

        this.filters.push({
            type,
            value: value.replace(/[\s\n\t]+/gm, ' ').trim().toLowerCase(),
        });

        this.closeSearchFilter();
        this.passingDuplicates.clear();
    }

    @HostListener('document:click', ['$event'])
    outClickOfferAmount(event: Event): void {
        if (this.searchFilterOpen && event.target instanceof HTMLElement && !event.target.closest('.search-container')) {
            this.closeSearchFilter();
        }
    }

    closeSearchFilter(): void {
        this.searchFilterOpen = false;
        this.filterType = 'NONE';
    }

    private needToShiftToLeft(event: Event): boolean {
        const target = event.target;

        if (target instanceof HTMLElement) {
            const container = target.closest('.f_table-container');
            const box =  target.getBoundingClientRect();
            const parentBox = container.getBoundingClientRect();

            if (parentBox.right - box.left < 170) {
                return true;
            }

        }

        return false;
    }

    openMultiselectFilter(type: 'TYPE' | 'DATE' | 'CREATOR' | 'EDITOR' | 'SOURCE' | 'COUNTRY', event: Event): void {
        this.shiftToLeft = this.needToShiftToLeft(event);

        setTimeout(() => {
            this.searchFilterOpen = false;
            this.filterType = type;

            this.updateMultiselectValues();

            setTimeout(() => {
                document.getElementById(this.filterType)?.click();
            }, 50);
        }, 10);
    }

    openSearchFilter(type: 'NUMBER' | 'TEXT' | 'EMAIL' | 'LAST_NAME' | 'FIRST_NAME', event: Event): void {
        this.shiftToLeft = this.needToShiftToLeft(event);
        this.searchFilterOpen = false;
        this.filterType = type;

        setTimeout(() => {
            this.searchFilterOpen = true;

            setTimeout(() => {
                document.getElementById(this.filterType)?.focus();
            }, 50)
        }, 50)
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.mandant?.currentValue) {
            this.getDuplicates();
        }
    }

    getDuplicates(): void {
        this.cloudDataService.getDuplicates(this.mandant.Id).subscribe(({success, data}) => {
            if (success) {
                this.duplicates = data;
            }
        })
    }

    onMultiselectChanged(value: string[]): void {
        this.filters = this.filters.filter(x => x.type !== this.filterType || value.includes(x.value));
        const filtersToAdd = this.multiselectOptions
            .filter(x => !this.filters.find(f => f.value === x.value) && value.includes(x.value));
        this.filters = this.filters.concat(filtersToAdd.map(x => ({value: x.value, type: this.filterType as any})));
        this.updateMultiselectValues();
    }

    protected readonly dateTimeHelper = DateTimeHelper;

    deleteFilter(i: number): void {
        this.filters.splice(i, 1);
        this.updateMultiselectValues();
    }

    clearFilters(): void {
        this.filters = [];
        this.updateMultiselectValues();
    }

    updateMultiselectValues(): void {
        const deduplicatedValues = [...new Set(this.duplicates.map(x => this.getValue(x, this.filterType)))].sort();
        this.multiselectOptions = deduplicatedValues.map(x => ({label: x, value: x}));
        this.selectedMultiselectOptions = this.multiselectOptions.filter(x => this.filters.find(f => f.type === this.filterType && f.value === x.value));
        this.passingDuplicates.clear();
    }

    getValue(duplicate: Duplicate, type: 'NONE' | 'NUMBER' | 'TEXT' | 'EMAIL' | 'LAST_NAME' |
        'FIRST_NAME' | 'TYPE' | 'DATE' | 'CREATOR' | 'EDITOR' | 'SOURCE' | 'COUNTRY'): string {
        switch (type) {
            case "TEXT":
                return duplicate.LeadText ?? '';
            case "EMAIL":
                return duplicate.Contact?.Email ?? '';
            case "FIRST_NAME":
                return duplicate.Contact?.FirstName ?? '';
            case "LAST_NAME":
                return duplicate.Contact?.LastName ?? '';
            case "TYPE":
                return duplicate.LeadTypeText;
            case "DATE":
                return this.dateTimeHelper.getFormattedDate( duplicate.CreTS );
            case "CREATOR":
                return duplicate.CreatorName ?? '';
            case "EDITOR":
                return duplicate.EditorName ?? '';
            case "SOURCE":
                return duplicate.LeadSourceText ?? '';
            case "COUNTRY":
                return duplicate.Address?.CountryCode ?? duplicate.Contact?.CountryCode ?? '';
            case "NUMBER":
                return duplicate.Number ?? '';
        }

        return '';
    }

    get isTableEmpty(): boolean {
        return !this.duplicates.find(x => this.passesFilter(x));
    }

    passesFilter(duplicate: Duplicate): boolean {
        if (this.passingDuplicates.has(duplicate)) {
            return this.passingDuplicates.get(duplicate);
        }

        const groupedMap = new Map<string, string[]>();

        for (const filter of this.filters) {
            const g = groupedMap.get(filter.type) ?? [];
            g.push(filter.value);
            groupedMap.set(filter.type, g);
        }

        for (const [type, values] of groupedMap) {
            let value = this.getValue(duplicate, type as any);

            if (['TYPE', 'DATE', 'CREATOR', 'EDITOR', 'SOURCE', 'COUNTRY'].includes(type)) {
                if (!values.includes(value)) {
                    this.passingDuplicates.set(duplicate, false);
                    return false;
                }
            } else {
                if (type === 'TEXT') {
                    value = TextHelper.htmlToText(value);
                }

                value = value.replace(/[\s\n\t]+/gm, ' ').trim().toLowerCase();

                if (values.findIndex(v => value.includes(v)) === -1) {
                    this.passingDuplicates.set(duplicate, false);
                    return false;
                }
            }
        }

        this.passingDuplicates.set(duplicate, true);
        return true;
    }
}
